<template>
    <div class="newPage">
        <div class="content">
            <div class="VOCNavBar">
                <div class="title">参数设置</div>
                <div class="navBarItem">
                    <div class="navBarTitle">开始日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">结束日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="title">站点</div>
                <div class="statisticBox scrollbar cityAndStation" v-loading="stationLoading">

                    <div class="item">
                        <el-radio-group v-model="queryParams.stations">
                            <div v-for="(item,index) in stationList" :key="index">
                                <el-radio :label='item.station'>
                                    {{item.station}}
                                </el-radio>
                            </div>
                        </el-radio-group>
                    </div>
                </div>
                <div class="btnBox">
                    <el-button type="primary" size="mini" @click="getList">查询</el-button>
                </div>
            </div>
            <div class="showContent">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-loading="loading">
                    <template  v-if="echartdata.type==='echart'">
                        <bar-chart class-name="chartBox" :echartdata="echartdata.data" ref="chart"/>
                    </template>
                    <template v-if="echartdata.type==='png'">
                        <div v-for="(item,index) in echartdata.list" :key="index" class="pngList">
                            <div class="pngDay">{{item.day}}</div>
                            <div class="pngImg"  v-if='item.url' >
                                <img :src="item.url"  alt="">
                                <div class="downBtn" @click="downAllImg(item.url)">下载</div>
                            </div>
                            <div  v-else class="pngMsg">{{item.msg}}</div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Breadcrumb from "../../components/breadcrumb";

    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }



    import url from "../../utils/UrlApi"

    import BarChart from "../../components/dashboard/BarChart";
    import {getNowFormatDate} from "../../utils";

    export default {
        name: "GHX_PollutionLevel",
        components: {BarChart, Breadcrumb},
        computed: {
            id: {
                get() {
                    return this.$route.query.id
                }
            },
            menuId: {
                get() {
                    return this.$route.query.menuId
                }
            }
        },
        data() {
            return {
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                queryParams: {
                    startTime: getNowFormatDate(-10),
                    endTime: getNowFormatDate(),
                    stations: '',
                },
                loading: false,
                stationLoading: false,
                stationList: [],
                myChart1: null,
                myChart2: null,
                echartdata: {}
            }
        },
        created() {
            this.getStationList()
        },
        methods: {
            init() {
                this.queryParams = {
                    startTime: getNowFormatDate(-10),
                    endTime: getNowFormatDate(),
                    stations: '',
                }

                if (this.$refs.chart){
                    this.$refs.chart.init()
                }

                this.echartdata = {}

            },
            getList() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                // data.stations = this.queryParams.stations.join()
                data.menuId = this.menuId

                if (!data.startTime) {
                    return this.$message.error('请选择开始时间')
                }
                if (!data.endTime) {
                    return this.$message.error('请选择结束时间')
                }
                if (!data.stations) {
                    return this.$message.error('请选择站点')
                }


                this.loading = true
                this.$http.get(url.vocDataAnalysisProxy, {
                    params: data
                }).then(res => {
                    console.log(res)
                    this.loading = false
                    if (res.data.code === '200') {
                        this.echartdata = res.data.data

                        if (res.data.data.type==='echart'){
                            setTimeout(() => {
                                this.$refs.chart.initChart()
                            })
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            //  查询 站点
            getStationList() {
                let data = {}
                this.stationLoading = true
                this.$http.get(url.vocDataAnalysis, {
                    params: data
                }).then(res => {
                    this.stationLoading = false
                    if (res.data.code === '200') {
                        this.stationList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            downAllImg(url){
                window.open(url, '_blank')
            },
        },
        beforeRouteUpdate(to, from, next) {
            //     路由切换
            //     初始化页面
            console.log('GHX 路由切换')
            next()
            this.init()
        },
    }
</script>

<style scoped lang="less">
    @import "../../assets/vocContent";

    /*.VOCContent{*/
    /*    width: 500px;*/
    /*    margin: 0 auto;*/
    /*}*/



    .cityAndStation {
        display: flex;
        .item {
            flex: 1;
            border-right: 1px solid #ddd;
            padding: 4px;
        }
        .item:last-child {
            border-right: 0;
        }
    }

    .dialog-footer {
        margin: 20px 0;
    }

        .downBtn{
            background-color: #2ca9dc;
            display: inline-block;
            padding: 4px 10px;
            text-align: center;
            color: #fff;
            border-radius: 2px;
            cursor: pointer;
        }

    .pngList{
        .pngDay{
            padding-left: 20px;
            font-weight: bold;
        }
        .pngMsg{
            padding-left: 24px;
            margin: 10px 0;
        }
        .pngImg{
            display: flex;
            align-items: flex-end;

            img{
                text-align: center;
                max-width: 100%;
            }
        }
    }
</style>
